import { render, staticRenderFns } from "./SocialNetworks.vue?vue&type=template&id=84a1de62&"
import script from "./SocialNetworks.vue?vue&type=script&setup=true&lang=js&"
export * from "./SocialNetworks.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports